import PortLabel from './PortLabel'

export default PortLabel
